import React, { lazy, useEffect, Suspense } from 'react' // 👈 1. Import Suspense
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import SuspenseContent from './containers/SuspenseContent';

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./pages/public/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const ResetPassword = lazy(() => import('./pages/public/ResetPassword'))
const Register = lazy(() => import('./pages/public/Register'))
const Documentation = lazy(() => import('./pages/Documentation'))
const ShareJobDetails = lazy(() => import('./pages/public/ShareJobDetails'))
const LandingPage = lazy(() => import('./pages/public/LandingPage'))
const TermsOfService = lazy(() => import('./pages/public/TermsOfService'))
const PrivacyPolicy = lazy(() => import('./pages/public/PrivacyPolicy'))
const RefundPolicy = lazy(() => import('./pages/public/RefundPolicy'))
const ToolsPage = lazy(() => import('./pages/public/ToolsPage'))
const PublicWorkspace = lazy(() => import('./pages/public/tools/PublicWorkspace'))
const SubtitleFixer = lazy(() => import('./pages/public/tools/SubtitleFixer'))
const MediaRecorderTool = lazy(() => import('./pages/public/tools/MediaRecorderTool'))
const MediaSplicerTool = lazy(() => import('./pages/public/tools/MediaSplicerTool'))
const AudioExtractorTool = lazy(() => import('./pages/public/tools/AudioExtractorTool'))
const ScriptTimerTool = lazy(() => import('./pages/public/tools/ScriptTimerTool'))
const VoiceEnhancerTool = lazy(() => import('./pages/public/tools/VoiceEnhancerTool'))
const VoiceMemoJoinerTool = lazy(() => import('./pages/public/tools/VoiceMemoJoinerTool'))
const SrtCleanerTool = lazy(() => import('./pages/public/tools/SrtCleanerTool'))
const FormatConverterTool = lazy(() => import('./pages/public/tools/FormatConverterTool'))
const GrammarTool = lazy(() => import('./pages/public/tools/GrammarTool'))

// Initializing different libraries
initializeApp()

// Check for login and initialize axios
const token = checkAuth()

function App() {

    useEffect(() => {
        themeChange(false)
    }, [])

    return (
        <>
            <Router>
                {/* 👇 3. Wrap Routes in Suspense to handle the lazy loading */}
                <Suspense fallback={<SuspenseContent />}>
                    <Routes>
                        {/* 🟢 PUBLIC ROUTES (Bypasses Layout & Token Checks) */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/refund-policy" element={<RefundPolicy />} />

                        <Route path="/tools" element={<ToolsPage />} />
                        <Route path="/tools/free-transcription" element={<PublicWorkspace />} />
                        <Route path="/tools/subtitle-fixer" element={<SubtitleFixer />} />
                        <Route path="/tools/media-recorder" element={<MediaRecorderTool />} />
                        <Route path="/tools/media-splicer" element={<MediaSplicerTool />} />
                        <Route path="/tools/audio-extractor" element={<AudioExtractorTool />} />
                        <Route path="/tools/script-timer" element={<ScriptTimerTool />} />
                        <Route path="/tools/voice-enhancer" element={<VoiceEnhancerTool />} />
                        <Route path="/tools/voice-memo-joiner" element={<VoiceMemoJoinerTool />} />
                        <Route path="/tools/srt-cleaner" element={<SrtCleanerTool />} />
                        <Route path="/tools/format-converter" element={<FormatConverterTool />} />
                        <Route path="/tools/grammar-checker" element={<GrammarTool />} />

                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/documentation" element={<Documentation />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/share/:token" element={<ShareJobDetails />} />

                        {/* 🔴 PROTECTED DASHBOARD ROUTES (Handles /workspace, etc.) */}
                        <Route path="/*" element={<Layout />} />

                        {/* Catch-all Redirect */}
                        <Route path="*" element={<Navigate to={token ? "/workspace" : "/login"} replace />}/>
                    </Routes>
                </Suspense>
            </Router>
        </>
    )
}

export default App